import { QueryClient } from "@tanstack/react-query";
import { lsGet } from '../utils/hooks';

export const getAuthQueryScope = () => {
  const token = lsGet("token");
  const user = lsGet("user");

  let userId = "guest";

  try {
    userId = user ? user?._id || user?.id || "guest" : "guest";
  } catch (error) {
    userId = "guest";
  }

  if (!token) {
    return `guest:${userId}`;
  }

  const tokenSuffix = String(token || "").slice(-16);

  return `auth:${userId}:${tokenSuffix}`;
};

export const withAuthQueryScope = (queryKey = []) => {
  const normalizedQueryKey = Array.isArray(queryKey) ? queryKey : [queryKey];
  return [...normalizedQueryKey, getAuthQueryScope()];
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,       // 30 seconds before refetch
      cacheTime: 5 * 60 * 1000,    // 5 minutes cache
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
